<template>
  <Wrapper
    bgColor="#d1faeb"
    inset
    contentWidth="md"
    wrapperHeight="viewport"
  >
    <div class="comparables py-12">

      <h2 class="text-center text-4xl mb-12">
        Comparable Properties
      </h2>

      <p class="text-center mb-12">
        Your estimated rental range was computed using these similar properties
      </p>

      <div class="flex flex-col flex-wrap md:flex-row items-start justify-around">

        <template v-for="comparable in comparables">

          <div class="w-full md:w-1/2 p-4">

            <div class="rounded bg-white p-4">

              <div class="font-bold whitespace-nowrap text-center">
                {{comparable.addressLine1}}
              </div>

              <div class="text-xs text-neutral-500 mb-3 text-center">
                {{comparable.bedrooms}} bed
                &middot; {{comparable.bathrooms}} bath
                &middot; {{comparable.squareFootage || '--'}} ft<sup>2</sup>
              </div>

              <div class="font-bold text-center">{{numeral(comparable.price).format('$0,0')}} month</div>
              <div class="text-xs text-neutral-500 text-center">
                $/ft<sup>2</sup> {{ comparable.squareFootage ? numeral((comparable.price  / comparable.squareFootage)).format('$0,0.00') : '--' }}
              </div>

            </div>

          </div>
        </template>
      </div>
    </div>
  </Wrapper>
</template>

<script>
import numeral from 'numeral';
import Wrapper from './Wrapper.vue';

export default {
  name: 'Comparables',
  components: {
    Wrapper,
  },
  computed: {
    comparables() {
      return this.estimate ? this.estimate.rent_cast_data.comparables.sort((a, b) => a.price > b.price ? 1 : -1) : [];
    },
  },
  data() {
    return {
      estimate: window.app.estimate,
    };
  },
  methods: {
    metrics(comparable) {
      return [
        {
          icon: 'bed-empty',
          label: 'Bed',
          value: comparable.bedrooms,
        },
        {
          icon: 'bath',
          label: 'Bath',
          value: comparable.bathrooms,
        },
        {
          icon: 'ruler-triangle',
          label: 'Sq Ft.',
          value: comparable.squareFootage ? this.numeral(comparable.squareFootage).format('0,0') : '?',
        },
      ];
    },
    numeral(value) {
      return numeral(value);
    },
  },
  props: {},
  watch: {},
}
</script>

<style scoped lang="scss">

</style>
